export default __webpack_public_path__ + "static/media/about.fd524ea3.png";